var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-swiper",
      class: {
        "rb-swiper--with-navigation-arrow": _vm.withNavigationArrow,
        "rb-swiper--with-navigation-text": !_vm.withNavigationArrow,
      },
      attrs: { "data-element-id": _vm.dataElementId },
    },
    [
      _vm.showNavigation
        ? _c(
            "div",
            {
              ref: "prevNavigation",
              staticClass: "swiper-button-prev",
              class: _vm.swiped ? "" : "hidden",
              on: { click: _vm.clickPrevButton },
            },
            [_vm._t("navigationprev")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "swiper",
          staticClass: "swiper-container",
          on: { click: _vm.onClick },
        },
        [
          _vm._t("wrapper", [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              [_vm._t("default")],
              2
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("pagination", null, {
        swiper: _vm.swiper,
        slides: _vm.slides,
        isCurrentIndex: _vm.isCurrentIndex,
        setCurrentIndex: _vm.setCurrentIndex,
      }),
      _vm._v(" "),
      _vm.showNavigation
        ? _c(
            "div",
            {
              ref: "nextNavigation",
              staticClass: "swiper-button-next",
              on: { click: _vm.clickNextButton },
            },
            [_vm._t("navigationnext")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dragIcon
        ? _c(
            "div",
            { ref: "dragNavigation", staticClass: "swiper-button-drag" },
            [_vm._t("navigationdrag")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showPagination
        ? _c("div", { ref: "pagination", staticClass: "swiper-pagination" })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }